import * as Yup from "yup";

export const esignSchema = Yup.object({
  sms: Yup
    .string()
    .test("len", "Needs to be at least 6 characters long", sms => sms && sms.length >= 6),
});